import { FileUploadProgressDTO } from "@js/DTO/FileUploadProgressDTO.cs.d";
import { AuthService } from "@js/services/AuthService";
import { CaseService } from "@js/services/CaseService";
import { FeedBackService } from "@js/services/FeedBackService";
import { RoleService } from "@js/services/RoleService";
import { SelectListService } from "@js/services/SelectListService";
import {
  CaseClient,
  CaseLenderClient,
  CaseLenderMessageClient,
  CaseLenderStateEnum,
  FeedBackClient,
  FileAttachmentClient,
  InterestRateTypeEnum,
  MessageRoleEnum,
  ModuleEnum,
  ProductTypeEnum,
  ProductClient,
  UserClient,
  CaseLender,
  Case,
  FileAttachment,
  FeedBack,
  DealLenderMessage,
  CaseLenderMessage,
  ApplicationUserCrudClient,
  CaseCrudClient,
  FileAttachmentCrudClient,
} from "@src/apis/ModularClient";
import { FileAttachmentHelper } from "@js/helpers/FileAttachmentHelper";
import ProductHelper from "@js/helpers/ProductHelper";
import { Expand, getOneUsingOData } from "@ccq/ts-lib";
import { IndexService } from "@js/services/IndexService";
import { ODataHelper } from "@js/helpers/ODataHelper";

export class HeadsOfTermsController {
  currentUser: { email: string; phoneNumber: string; fullName: string; id: number; isConnectUser: boolean };
  isDevelopmentFinance: boolean = true;
  dataLoading: boolean = false; // Controls showing the data loading "spinner"
  caseLenders: CaseLender[];
  showInformationMessage: boolean = false;
  messageContent: string;
  feedbackMessageToLender: string;

  showDirection: boolean = false;

  toggleFeedbackSection: boolean = false;
  toggleHoTDetailSection: boolean = false;
  toggleRejectSection: boolean = false;
  toggleWithdrawSection: boolean = false;
  isLender: boolean = false;
  isBroker: boolean = false;
  isAdmin: boolean = false;
  isClient: boolean = false;

  // show different sections to Lender based on which button clicked on Case Dashboard
  showFeedbackSectionLender: boolean = false;
  showHoTDetailSectionLender: boolean = false;
  showRejectSectionLender: boolean = false;
  showWithdrawSectionLender: boolean = false;

  showTsAndCsModal: boolean = false;
  showTsAndCsForm: boolean = false;
  sendingMessage: boolean = false;
  goToUserDashboard: boolean = false;

  currentCase: Expand<Case, { readonly developmentInput: true; readonly attachments: true }>;
  currentCaseLender: CaseLender;
  grossLoanCalcVal: number = 0;
  builLoanCalcVal: number = 0;
  landLoanCalcVal: number = 0;
  monetaryLAFee: number = 0;
  monetaryLEFee: number = 0;
  lenderTask: string = "";
  netBuildLoanCalcVal: number = 0;

  isRejectClicked: boolean = false;
  isWithdrawClicked: boolean = false;
  isConfirmClicked: boolean = false;
  isSubmitClicked: boolean = false;

  //Lender Message
  newChatMessage: string = "";
  showFullMessageId: number;

  //files
  fileUpload: Expand<FileAttachment>[];
  uploadingFiles: FileUploadProgressDTO[];
  openModal: boolean = false;
  module = ModuleEnum.DIP;

  showFullLenderMessage = false;
  showFullBorrowerMessage = false;
  InterestRateTypeOptions = [];

  showLenderFeedBackModal: boolean = false;
  showBrokerFeedBackModal: boolean = false;
  feedBackDTO: FeedBack;
  prevPath: string;

  brokerName: string;
  brokerOrganisationName: string;

  //Deleteing a chat message
  selectedDealLenderMessageDto: DealLenderMessage;
  showdeleteChatMessageModal: boolean = false;
  showConfirmDeleteButton: boolean = false;

  productTypeText: string = null;

  static $inject = [
    "$routeParams",
    "$rootScope",
    "$location",
    "CaseService",
    "CaseClient",
    "CaseLenderClient",
    "RoleService",
    "CaseLenderMessageClient",
    "FileAttachmentClient",
    "FileAttachmentHelper",
    "$window",
    "SelectListService",
    "FeedBackService",
    "FeedBackClient",
    "UserClient",
    "AuthService",
    "ProductClient",
    "ApplicationUserCrudClient",
    "IndexService",
    "CaseCrudClient",
    "ODataHelper",
    "FileAttachmentCrudClient",
  ];

  constructor(
    private $routeParams: ng.route.IRouteParamsService,
    private $rootScope: ng.IRootScopeService,
    private $location: ng.ILocationService,
    private caseService: CaseService,
    private caseClient: CaseClient,
    private caseLenderClient: CaseLenderClient,
    private roleService: RoleService,
    private caseLenderMessageClient: CaseLenderMessageClient,
    private fileAttachmentClient: FileAttachmentClient,
    private fileAttachmentHelper: FileAttachmentHelper,
    private $window: ng.IWindowService,
    private selectListService: SelectListService,
    private feedBackService: FeedBackService,
    private feedBackClient: FeedBackClient,
    private userService: UserClient,
    private $auth: AuthService,
    private productClient: ProductClient,
    private applicationUserCrudClient: ApplicationUserCrudClient,
    private indexService: IndexService,
    private caseCrudClient: CaseCrudClient,
    private odataHelper: ODataHelper,
    private fileAttachmentCrudClient: FileAttachmentCrudClient,
  ) {
    this.feedBackDTO = {} as FeedBack;
    if (this.$routeParams.openModule && this.$routeParams.openModule == "withdraw") {
      this.toggleWithdrawSection = true;
    } else if (this.$routeParams.openModule && this.$routeParams.openModule == "reject") {
      this.toggleRejectSection = true;
    } else if (this.$routeParams.openModule) {
      this.toggleFeedbackSection = true;
    }

    if (this.$routeParams.CaseId && this.$routeParams.CaseLenderId) {
      this.dataLoading = true;

      this.odataHelper
        .getOne(this.caseCrudClient, {
          filter: {
            id: {
              eq: Number(this.$routeParams.CaseId),
            },
          },
          expand: {
            developmentInput: true,
          },
        })
        .then((response) => {
          this.odataHelper
            .getMany(this.fileAttachmentCrudClient, {
              filter: {
                caseId: {
                  eq: Number(this.$routeParams.CaseId),
                },
              },
            })
            .then((attachments) => {
              this.currentCase = response as typeof response & { attachments: any[] };
              this.currentCase.attachments = attachments;

              if (this.currentCase) {
                this.caseLenderClient
                  .fetchByCaseId(
                    this.$routeParams.CaseId,
                    this.roleService.getIsLenderVisible(),
                    this.$routeParams.CaseLenderId,
                  )
                  .then((response) => {
                    this.caseLenders = response;
                    if (this.$routeParams.CaseLenderId) {
                      this.currentCaseLender = this.caseLenders.find((caseLender) => {
                        return caseLender.id == this.$routeParams.CaseLenderId;
                      });
                      this.fileUpload = this.currentCase.attachments.filter((f) => {
                        return f.caseLenderId == this.$routeParams.CaseLenderId;
                      });
                      //this.recalculateArrangementPercent(); //  this actually re-calculates the arrangement fee not the % - function name is wrong
                      // this.recalculateExitPercent(); //  this actually re-calculates the exit fee not the % - function name is wrong
                      this.calculateGrossLoanValVal();
                      this.calculateBuildLoadCalcVal();
                      this.calculateLandLoanCalcVal();
                      // this.calculatemonetaryLAFee();
                      //this.calculatemonetaryLEFee();
                    }
                  });
                this.caseService.updateCaseState(this.currentCase.id, this.currentCase.caseStatus);
                this.lenderTask = sessionStorage.getItem("lenderTask");
                if (this.lenderTask != null && this.lenderTask.length > 0) {
                  switch (this.lenderTask) {
                    case "reject":
                      this.showRejectSectionLender = true;
                      break;
                    case "withdraw":
                      this.showWithdrawSectionLender = true;
                      break;
                    case "feedback":
                      this.showFeedbackSectionLender = true;
                      this.updateCaseLenderMessageReadDatetime();
                      break;
                    case "terms":
                      this.showHoTDetailSectionLender = true;
                      break;
                    default:
                      break;
                  }
                }

                this.productTypeText = ProductHelper.getProductTypeFullName(ProductTypeEnum.Development);
              } else {
                if ((this.$rootScope as any).selectedUser) {
                  this.$location.path("/dashboard");
                }
              }
            });
        })
        .finally(() => {
          this.dataLoading = false;
          this.getCurrentUserAndRoles();
        });
    }

    this.InterestRateTypeOptions = this.selectListService.GetInterestRateType();
  }

  /**Process the Send Feedback button being clicked */
  /* sendFeedbackClicked() {
            this.caseLenderClient.sendFeedbackToBorrower(this.currentCaseLender, this.currentCase.developmentInput.ownerUser).then((response) => {
                //this.caseLenders = this.caseLenders.filter(lender => lender.Id != this.currentCaseLender.id);
                //this.caseLenders.push(response);
                this.messageContent = 'Your feedback has been sent to the borrower.';
                this.goToUserDashboard = true;
            }).catch((error) => {
                this.messageContent = 'Sorry, something went wrong while sending feedback to the borrower. Please try again.';
            }).finally(() => {
                this.showInformationMessage = true;
            })
        }*/

  /**Calculate the Total Net Loan */
  calculateTotalNetLoan() {
    var totalNetLoan: number = 0;
    if (this.currentCaseLender && this.currentCaseLender.buildLoan && this.currentCaseLender.landLoan) {
      totalNetLoan = +this.currentCaseLender.buildLoan + +this.currentCaseLender.landLoan;
      totalNetLoan = Math.round(totalNetLoan * 100) / 100;
    }
    return totalNetLoan;
  }

  checkingIfUserIsLender() {
    this.roleService.isLenderUser().then((response) => {
      this.isLender = response;
    });
  }

  checkingIfUerIsBroker() {
    this.dataLoading = true;
    this.roleService
      .isBroker()
      .then((response) => {
        this.isBroker = response;
      })
      .finally(() => {
        this.dataLoading = false;
      });
  }

  checkingIfUserIsAdmin() {
    this.dataLoading = true;
    this.roleService
      .isAdminUser()
      .then((response) => {
        this.isAdmin = response;
      })
      .finally(() => {
        this.dataLoading = false;
      });
  }

  checkingIfUserIsClient() {
    this.dataLoading = true;
    this.roleService
      .isClientUser()
      .then((response) => {
        this.isClient = response;
      })
      .finally(() => {
        this.dataLoading = false;
      });
  }

  /**Calculate total lender costs */
  totalLenderCosts() {
    var lenderCosts: number = 0;

    if (this.currentCaseLender) {
      lenderCosts =
        +this.currentCaseLender.lenderArrangementFee +
        +this.currentCaseLender.lenderExitFee +
        +this.currentCaseLender.interestCoverAllocation;
    }
    return lenderCosts;
  }

  /**Calculate Arrangement Amount */
  recalculateArrangementAmount() {
    if (this.currentCaseLender && this.currentCaseLender.totalGrossLoan) {
      //const element = event.currentTarget as HTMLInputElement
      //const value = parseFloat(element.value)

      //this.currentCaseLender.lenderArrangementFee = value;

      this.currentCaseLender.lenderArrangementFeePercent =
        (this.currentCaseLender.lenderArrangementFee * 100) / this.currentCaseLender.totalGrossLoan;
      this.currentCaseLender.lenderArrangementFeePercent = parseFloat(
        this.currentCaseLender.lenderArrangementFeePercent.toFixed(2),
      );

      this.totalLenderCosts();
    }
  }

  /**Calculate borrower equity
         (Puchase Price - land loan)
         */
  calculateBorrowerEquity() {
    var borrowerEquity: number = 0;

    if (
      this.currentCase &&
      this.currentCase.developmentInput.cI_Dev_OrigPP &&
      this.currentCaseLender &&
      this.currentCaseLender.landLoan
    ) {
      borrowerEquity = this.currentCase.developmentInput.cI_Dev_OrigPP - this.currentCaseLender.landLoan;
    }
    return Number(borrowerEquity);
  }

  /**Calculate true cost */
  calculateTrueCost(): number {
    if (this.currentCaseLender) {
      var trueCost: number =
        +this.currentCaseLender.interestRate / 12 +
        (+this.currentCaseLender.lenderArrangementFeePercent + +this.currentCaseLender.lenderExitFeePercent) /
          +this.currentCase.developmentInput.cI_Dev_LoanTermReq;
      return trueCost;
    }
  }

  /**Re-calculate arrangement percent */
  recalculateArrangementPercent() {
    //const element = event.currentTarget as HTMLInputElement
    //const value = parseFloat(element.value)
    if (this.currentCaseLender && this.currentCaseLender.totalGrossLoan) {
      //this.currentCaseLender.lenderArrangementFeePercent = value;
      this.currentCaseLender.lenderArrangementFee =
        (this.currentCaseLender.totalGrossLoan * this.currentCaseLender.lenderArrangementFeePercent) / 100;
      this.currentCaseLender.lenderArrangementFee = Math.round(this.currentCaseLender.lenderArrangementFee * 100) / 100;
      this.totalLenderCosts();
    }
  }

  /**Recalculate Exit Amount */
  recalculateExitAmount() {
    const element = event.currentTarget as HTMLInputElement;
    const value = parseFloat(element.value);
    if (this.currentCaseLender && this.currentCaseLender.totalGrossLoan) {
      this.currentCaseLender.lenderExitFee = value;

      this.currentCaseLender.lenderExitFeePercent =
        (this.currentCaseLender.lenderExitFee * 100) / this.currentCaseLender.totalGrossLoan;
      /*this.currentCaseLender.lenderExitFeePercent = parseInt(this.currentCaseLender.lenderExitFeePercent.toFixed(2));*/
      this.currentCaseLender.lenderExitFeePercent = Math.round(this.currentCaseLender.lenderExitFeePercent * 100) / 100;
      this.totalLenderCosts();
    }
  }

  /**Recalculate Exit Percent */
  recalculateExitPercent() {
    //const element = event.currentTarget as HTMLInputElement
    //const value = parseFloat(element.value)
    if (
      this.currentCaseLender &&
      this.currentCaseLender.totalGrossLoan &&
      this.currentCaseLender.lenderExitFeePercent
    ) {
      //this.currentCaseLender.lenderExitFeePercent = value;
      this.currentCaseLender.lenderExitFee =
        (this.currentCaseLender.totalGrossLoan * this.currentCaseLender.lenderExitFeePercent) / 100;
      this.currentCaseLender.lenderExitFee = Math.round(this.currentCaseLender.lenderExitFee * 100) / 100;
      this.totalLenderCosts();
    }
  }

  /** Redirects to the case dashboard */
  goToCaseDashboard() {
    this.showFeedbackSectionLender = false;
    this.showHoTDetailSectionLender = false;
    this.showRejectSectionLender = false;
    this.showWithdrawSectionLender = false;
    if (
      this.isBroker &&
      !this.currentCaseLender.isLenderReviewComplete &&
      (this.currentCaseLender.caseLenderState == CaseLenderStateEnum.Offered ||
        this.currentCaseLender.caseLenderState == CaseLenderStateEnum.Rejected ||
        this.currentCaseLender.caseLenderState == CaseLenderStateEnum.Withdrawn)
    ) {
      this.prevPath = "casedashboard";
      this.feedBackDTO.isLenderFeedback = true;
      this.showLenderFeedBackModal = true;
    } else {
      this.$location.path("/casedashboard/" + this.currentCase.id);
    }
  }

  /** Close modal after send feedback */
  closeModal() {
    this.showDirection = false;
    this.showTsAndCsModal = false;
    this.showInformationMessage = false;
    this.isConfirmClicked = false;
    this.showdeleteChatMessageModal = false;
    if (this.goToUserDashboard) {
      this.$auth.clearSelectedNavMenuAndFilterStorageData();
      this.$location.path("/userdashboard");
      this.goToUserDashboard = false;
      this.showFeedbackSectionLender = false;
      this.showHoTDetailSectionLender = false;
      this.showRejectSectionLender = false;
      this.showWithdrawSectionLender = false;
    }

    if (this.prevPath) {
      if (this.isLender) {
        this.$auth.clearSelectedNavMenuAndFilterStorageData();
        this.$location.path("/userdashboard");
      } else {
        this.$location.path(`/${this.prevPath}/${this.currentCase.id}`);
      }
    }
  }

  goToLending() {
    if (
      this.isBroker &&
      !this.currentCaseLender.isLenderReviewComplete &&
      (this.currentCaseLender.caseLenderState == CaseLenderStateEnum.Offered ||
        this.currentCaseLender.caseLenderState == CaseLenderStateEnum.Rejected ||
        this.currentCaseLender.caseLenderState == CaseLenderStateEnum.Withdrawn)
    ) {
      this.prevPath = "lending";
      this.feedBackDTO.isLenderFeedback = true;
      this.showLenderFeedBackModal = true;
    } else {
      this.$location.path("/lending/" + this.currentCase.id);
    }
  }

  saveUpdatedCaseLender(): void {
    //TODO JLH debug this process, seems a bit odd
    this.caseLenderClient.addUpdate(this.currentCaseLender).then((response) => {
      //TODO JLH debug this process, seems a bit odd
      this.caseLenders = this.caseLenders.filter((lender) => lender.id != this.currentCaseLender.id);
      this.caseLenders.push(response);

      this.messageContent = "Your changes have been saved.";
      this.showInformationMessage = true;
    });
  }

  /** Process the Lender button being clicked*/
  lenderClicked() {
    (this.$rootScope as any).isLender = false; // TODO JLH why is this being set to false?  What if the user is a lender?
    this.$location.path("/lending/" + this.currentCase.id);
  }

  /** Process the Reject button being clicked*/
  rejectClicked(): void {
    this.isRejectClicked = true;
    this.caseLenderClient
      .rejectCase(this.currentCaseLender)
      .then((response) => {
        this.currentCaseLender.caseLenderState = response.caseLenderState;
        this.brokerName = response.dealBrokerName;
        this.brokerOrganisationName = response.dealBrokerOrganisationName;
        this.messageContent = "The borrower has been notified you have rejected their application.";
        //TODO JLH debug this process, seems a bit odd
        this.caseLenders = this.caseLenders.filter((lender) => lender.id != this.currentCaseLender.id);
        this.caseLenders.push(this.currentCaseLender);
      })
      .catch((error) => {
        this.messageContent = "Sorry, something went wrong. Please try again.";
        this.isRejectClicked = false;
      })
      .finally(() => {
        this.goToUserDashboard = true;
        this.currentCaseLender.isBrokerReviewComplete || this.currentCase.brokerOrganisationId == null || !this.isLender
          ? (this.showInformationMessage = true)
          : this.showBrokerFeedBack();
      });
  }

  /**Process the Withdraw button being clicked */
  withdrawClicked(): void {
    this.isWithdrawClicked = true;
    this.caseLenderClient
      .withdrawHoT(this.currentCaseLender)
      .then((response) => {
        //TODO JLH what is being returned here?  the whole case?
        this.currentCaseLender.caseLenderState = response.caseLenderState;
        this.brokerName = response.dealBrokerName;
        this.brokerOrganisationName = response.dealBrokerOrganisationName;
        this.messageContent = "The borrower has been notified you have withdrawn terms for their application.";
        //TODO JLH debug this process, seems a bit odd
        this.caseLenders = this.caseLenders.filter((lender) => lender.id != this.currentCaseLender.id);
        this.caseLenders.push(this.currentCaseLender);
      })
      .catch((error) => {
        this.messageContent = "Sorry, something went wrong. Please try again.";
        this.isWithdrawClicked = false;
      })
      .finally(() => {
        this.goToUserDashboard = true;
        this.currentCaseLender.isBrokerReviewComplete || this.currentCase.brokerOrganisationId == null || !this.isLender
          ? (this.showInformationMessage = true)
          : this.showBrokerFeedBack();
      });
  }

  /**Process the Submit button being clicked */
  submitClicked() {
    this.isConfirmClicked = true;
    this.showTsAndCsModal = true;
  }

  /**Heads of Terms Submit button clicked event */
  submitHoTClicked() {
    // Close the Heads of Terms' Terms and Conditions modal
    this.showTsAndCsModal = false;
    this.sendingMessage = true;
    // Submit the Heads of Terms
    this.caseLenderClient
      .submitHoT(this.currentCaseLender.caseLenderState, this.currentCaseLender)
      .then((response) => {
        this.currentCaseLender.caseLenderState = response.caseLenderState;
        this.brokerName = response.dealBrokerName;
        this.brokerOrganisationName = response.dealBrokerOrganisationName;
        this.caseLenders = this.caseLenders.filter((lender) => lender.id != this.currentCaseLender.id);
        this.caseLenders.push(this.currentCaseLender);
        this.messageContent = "Thank you for submitting a Decision in Principle.";
        this.goToUserDashboard = true;
      })
      .catch((error) => {
        this.messageContent =
          "Sorry, something went wrong while submitting your Decision in Principle. Please try again.";
        this.isConfirmClicked = false;
      })
      .finally(() => {
        this.sendingMessage = false;
        this.currentCaseLender.isBrokerReviewComplete || this.currentCase.brokerOrganisationId == null || !this.isLender
          ? (this.showInformationMessage = true)
          : this.showBrokerFeedBack();
      });
  }

  showBrokerFeedBack() {
    this.feedBackDTO.isBrokerFeedback = true;
    this.showBrokerFeedBackModal = true;
  }

  /**
   * Process the Send Feedback button being clicked
   * @param message
   */
  /*   sendlenderFeedbackClicked() {
            this.caseLenderClient.sendFeedbackToLender(this.currentCaseLender).then((response) => {
                this.messageContent = `Your feedback has been sent to ${this.currentCaseLender.loanLabel != null ? this.currentCaseLender.loanLabel:'the lender'}.`;
                this.feedbackMessageToLender = '';
                this.showInformationMessage = true;
            }).catch((error) => {
                this.messageContent = 'Sorry, something went wrong while sending feedback to lender. Please try again.';
            });
        }*/

  /**
   * Process the Apply button being clicked
   * @param currentCaseLender
   */
  applyClicked(selectedCaseLender: CaseLender) {
    // Show the Terms and Conditions modal
    this.showTsAndCsModal = true;
  }

  /**Process the Submit Terms and Conditions button being clicked */
  submitTsAndCsClicked() {
    this.isSubmitClicked = true;
    this.showTsAndCsModal = false;

    this.$location.path("/payment/" + this.currentCase.id);

    //TODO JLH need to wait for payment to be complete before actually applying ideally

    this.caseLenderClient
      .applyToLender(this.currentCaseLender.caseId, this.currentCaseLender.id, true)
      .then((response) => {
        this.currentCaseLender.caseLenderState = response.caseLenderState;
      })
      .finally(() => {
        this.messageContent = `Thank you for submitting an application with ${
          this.currentCaseLender.loanLabel != null ? this.currentCaseLender.loanLabel : "this lender"
        }.`;
        this.showInformationMessage = true;
      });
  }

  calculateGrossLoanValVal() {
    if (
      this.currentCaseLender.totalGrossLoan != null &&
      this.currentCaseLender.totalGrossLoan >= 0 &&
      this.currentCase.developmentInput.cI_GDVCalculated != null &&
      this.currentCase.developmentInput.cI_GDVCalculated >= 0
    ) {
      this.grossLoanCalcVal = parseFloat(
        ((this.currentCaseLender.totalGrossLoan / this.currentCase.developmentInput.cI_GDVCalculated) * 100).toFixed(2),
      );
    }

    if (this.currentCaseLender.totalGrossLoan != null && this.currentCaseLender.totalGrossLoan > 0) {
      if (
        this.currentCaseLender.lenderArrangementFeePercent != null &&
        this.currentCaseLender.lenderArrangementFeePercent > 0
      ) {
        this.calculatemonetaryLAFee();
      } else {
        if (this.currentCaseLender.lenderArrangementFee != null && this.currentCaseLender.lenderArrangementFee > 0) {
          this.calculatemonetaryLAPercent();
        }
      }

      if (this.currentCaseLender.lenderExitFeePercent != null && this.currentCaseLender.lenderExitFeePercent > 0) {
        this.calculatemonetaryLEFee();
      } else {
        if (this.currentCaseLender.lenderExitFee != null && this.currentCaseLender.lenderExitFee > 0) {
          this.calculatemonetaryLEPercent();
        }
      }
    } else {
      this.currentCaseLender.lenderArrangementFeePercent = 0;
      this.currentCaseLender.lenderArrangementFee = 0;
      this.currentCaseLender.lenderExitFeePercent = 0;
      this.currentCaseLender.lenderExitFee = 0;
    }
  }

  calculateBuildLoadCalcVal() {
    if (this.currentCaseLender.buildLoan != null && this.currentCaseLender.buildLoan >= 0) {
      this.builLoanCalcVal = parseFloat(((this.currentCaseLender.buildLoan / this.CalcTotalBuild()) * 100).toFixed(2));
    }
  }

  calculateLandLoanCalcVal() {
    if (this.currentCaseLender.landLoan != null && this.currentCaseLender.landLoan >= 0) {
      this.landLoanCalcVal = parseFloat(
        ((this.currentCaseLender.landLoan / this.currentCase.developmentInput.cI_Dev_OrigPP) * 100).toFixed(2),
      );
    }
  }

  calculatemonetaryLAFee() {
    if (
      this.currentCaseLender.lenderArrangementFeePercent != null &&
      this.currentCaseLender.lenderArrangementFeePercent > 0 &&
      this.currentCaseLender.totalGrossLoan != null &&
      this.currentCaseLender.totalGrossLoan > 0
    ) {
      this.currentCaseLender.lenderArrangementFee =
        Math.round(this.currentCaseLender.totalGrossLoan * this.currentCaseLender.lenderArrangementFeePercent * 100) /
        100;
    } else {
      this.currentCaseLender.lenderArrangementFee = 0;
    }
  }

  calculatemonetaryLAPercent() {
    if (
      this.currentCaseLender.lenderArrangementFee != null &&
      this.currentCaseLender.lenderArrangementFee > 0 &&
      this.currentCaseLender.totalGrossLoan != null &&
      this.currentCaseLender.totalGrossLoan > 0
    ) {
      this.currentCaseLender.lenderArrangementFeePercent =
        this.currentCaseLender.lenderArrangementFee / this.currentCaseLender.totalGrossLoan;

      this.currentCaseLender.lenderArrangementFeePercent = parseFloat(
        this.currentCaseLender.lenderArrangementFeePercent.toFixed(4),
      );
    } else {
      this.currentCaseLender.lenderArrangementFeePercent = 0;
    }
  }

  calculatemonetaryLEFee() {
    if (
      this.currentCaseLender.lenderExitFeePercent != null &&
      this.currentCaseLender.lenderExitFeePercent > 0 &&
      this.currentCaseLender.totalGrossLoan != null &&
      this.currentCaseLender.totalGrossLoan > 0
    ) {
      this.currentCaseLender.lenderExitFee =
        Math.round(this.currentCaseLender.totalGrossLoan * this.currentCaseLender.lenderExitFeePercent * 100) / 100;
    } else {
      this.currentCaseLender.lenderExitFee = 0;
    }
  }

  calculatemonetaryLEPercent() {
    if (
      this.currentCaseLender.lenderExitFee != null &&
      this.currentCaseLender.lenderExitFee > 0 &&
      this.currentCaseLender.totalGrossLoan != null &&
      this.currentCaseLender.totalGrossLoan > 0
    ) {
      this.currentCaseLender.lenderExitFeePercent =
        this.currentCaseLender.lenderExitFee / this.currentCaseLender.totalGrossLoan;
      this.currentCaseLender.lenderExitFeePercent = parseFloat(this.currentCaseLender.lenderExitFeePercent.toFixed(4));
    } else {
      this.currentCaseLender.lenderExitFeePercent = 0;
    }
  }

  CalcTotalBuild(): number {
    var res: number = this.CalcAdditionalBuild();
    if (this.currentCase && this.currentCase.developmentInput.cI_Dev_BuildCosts) {
      res += Number(this.currentCase.developmentInput.cI_Dev_BuildCosts);
    }

    res += this.calcContingencyCost();
    return res;
  }

  CalcAdditionalBuild(): number {
    var res: number = 0;
    if (this.currentCase.developmentInput.dI_BreakDownBuildCosts) {
      if (this.currentCase.developmentInput.cI_Dev_ProfPlanning) {
        res += Number(this.currentCase.developmentInput.cI_Dev_ProfPlanning);
      }
      if (this.currentCase.developmentInput.cI_Dev_ProfQS) {
        res += Number(this.currentCase.developmentInput.cI_Dev_ProfQS);
      }
      if (this.currentCase.developmentInput.dI_BuildProjectManag) {
        res += Number(this.currentCase.developmentInput.dI_BuildProjectManag);
      }
      if (this.currentCase.developmentInput.cI_Dev_S106CIL) {
        res += Number(this.currentCase.developmentInput.cI_Dev_S106CIL);
      }
      if (this.currentCase.developmentInput.dI_BuildMechEng) {
        res += Number(this.currentCase.developmentInput.dI_BuildMechEng);
      }
      if (this.currentCase.developmentInput.dI_BuildStrucEng) {
        res += Number(this.currentCase.developmentInput.dI_BuildStrucEng);
      }
      if (this.currentCase.developmentInput.dI_BuildPartyWall) {
        res += Number(this.currentCase.developmentInput.dI_BuildPartyWall);
      }
      if (this.currentCase.developmentInput.dI_BuildLandscaping) {
        res += Number(this.currentCase.developmentInput.dI_BuildLandscaping);
      }
      if (this.currentCase.developmentInput.dI_BuildWarranty) {
        res += Number(this.currentCase.developmentInput.dI_BuildWarranty);
      }
      if (this.currentCase.developmentInput.dI_BuildDemolition) {
        res += Number(this.currentCase.developmentInput.dI_BuildDemolition);
      }
      if (this.currentCase.developmentInput.dI_BuildOtherCosts) {
        res += Number(this.currentCase.developmentInput.dI_BuildOtherCosts);
      }
    } else {
      if (this.currentCase.developmentInput.cI_Dev_AdditionalOngoingCosts) {
        res += Number(this.currentCase.developmentInput.cI_Dev_AdditionalOngoingCosts);
      }
    }
    return res;
  }

  calcContingencyCost(): number {
    var res: number = 0;
    if (this.currentCase.developmentInput.cI_Dev_Contingency && this.currentCase.developmentInput.cI_Dev_BuildCosts) {
      res = this.currentCase.developmentInput.cI_Dev_Contingency * this.currentCase.developmentInput.cI_Dev_BuildCosts;
      return res;
    }
    return res;
  }

  /**
   * Process the Send Feedback button being clicked
   * @param message
   */
  sendChatMessage() {
    this.dataLoading = true;

    const CaseChatMessage = {
      message: this.newChatMessage,
      caseId: this.$routeParams.CaseId,
      case: null,
      caseLenderId: this.$routeParams.CaseLenderId,
      caseLender: null,
      senderUser: null,
      senderUserId: this.currentUser.id,
      senderRole: this.getSenderMessageRole(),
      recipientRoles: this.isLender ? MessageRoleEnum.Client | MessageRoleEnum.Broker : MessageRoleEnum.Lender,
      user: null,
      messageReadDateTime: null,
      organisationLogo: "",
      userFullName: "",
      id: 0,
      userId: null,
      isDeleted: false,
      createdDateTime: null,
      lastUpdatedDateTime: null,
      lastModifiedUser: null,
      lastModifiedUserId: null,
      createdUserId: null,
      createdUser: null,
    } as CaseLenderMessage;

    this.caseLenderMessageClient
      .addUpdateAndSendNotification(CaseChatMessage)
      .then((caseChatMessageResponse) => {
        this.currentCaseLender.caseLenderMessage.push(caseChatMessageResponse);
        this.newChatMessage = null;
      })
      .catch((error) => {
        this.messageContent = "Sorry, something went wrong while sending feedback. Please try again.";
      })
      .finally(() => {
        this.dataLoading = false;
      });
  }

  showFullChatMessage(index) {
    this.showFullMessageId = index;
  }

  updateCaseLenderMessageReadDatetime() {
    this.caseLenderMessageClient
      .updateCaseLenderMessageReadDatetime(this.$routeParams.CaseLenderId)
      .then((caseLenderMessageResponse) => {})
      .catch((error) => {});
  }

  onFileSelect(files: FileAttachment[], module: ModuleEnum) {
    if (files.length > 0) {
      this.fileAttachmentHelper
        .UploadFileLstInSync(
          files,
          this.uploadingFiles,
          this.$routeParams.CaseId,
          this.fileUpload,
          module,
          this.$routeParams.CaseLenderId,
        )
        .then((result) => {
          this.openModal = false;
        });
    }
  }

  downloadFile(file: FileAttachment) {
    this.dataLoading = true;
    this.fileAttachmentClient
      .getAmazonFileAccessUri(file.fileLocation)
      .then((uri) => {
        this.$window.open(uri);
      })
      .finally(() => {
        this.dataLoading = false;
      });
  }

  deleteFile(file: FileAttachment) {
    this.fileUpload.splice(this.fileUpload.indexOf(file), 1);
    this.fileAttachmentClient.markAsDeleted(file.id).then((result) => {}); //remove on the server
  }

  getRateTypeText(e: InterestRateTypeEnum) {
    switch (e) {
      case InterestRateTypeEnum.Fixed:
        return "Fixed";
      case InterestRateTypeEnum.Variable:
        return "Variable";
      default:
        break;
    }
  }

  addClass(star: number, id: string) {
    this.feedBackService.addClass(star, id);
  }

  removeClass(star: number, id: string, rating) {
    this.feedBackService.removeClass(star, id, rating);
  }

  isFeedBackFormDisabled() {
    return this.feedBackService.isFeedBackFormDisabled(this.isLender, this.feedBackDTO);
  }

  updateRating(star, rating) {
    this.feedBackDTO = this.feedBackService.updateRating(star, rating, this.feedBackDTO);
  }

  submitFeedBack() {
    if (this.isLender) {
      this.feedBackDTO.organisationId = this.currentCase.brokerOrganisationId;
      this.feedBackDTO.brokerUserId = this.currentCase.brokerUserId;
      this.feedBackDTO.organisation = null;
      this.feedBackDTO.brokerUser = null;
      this.feedBackDTO.reviewerUserId = 0;
      this.feedBackDTO.reviewerUser = null;
    } else {
      this.feedBackDTO.lenderId = this.currentCaseLender.lenderId;
      this.feedBackDTO.lender = null;
      this.feedBackDTO.reviewerUserId = 0;
      this.feedBackDTO.reviewerUser = null;
    }

    this.feedBackClient.addFeedBack(this.currentCaseLender.id, false, this.feedBackDTO).then((response) => {
      if (this.isLender) {
        this.$auth.clearSelectedNavMenuAndFilterStorageData();
        this.$location.path("/userdashboard");
      } else {
        this.$location.path(`/${this.prevPath}/${this.currentCase.id}`);
      }
    });
  }

  onClickDeleteMessageButton(message: DealLenderMessage) {
    this.showdeleteChatMessageModal = true;
    this.messageContent = "Are you sure you want to delete a selected message?";
    this.selectedDealLenderMessageDto = message;
    this.showConfirmDeleteButton = true;
  }

  deleteChatMessage() {
    this.dataLoading = true;
    this.caseLenderMessageClient
      .markAsDeleted(this.selectedDealLenderMessageDto.id)
      .then((response) => {
        this.currentCaseLender.caseLenderMessage = this.currentCaseLender.caseLenderMessage.filter(
          (x) => x.id != this.selectedDealLenderMessageDto.id,
        );
      })
      .catch((error) => {
        this.messageContent = "Sorry, something went wrong while deleting message. Please try again.";
      })
      .finally(() => {
        this.showdeleteChatMessageModal = false;
        delete this.selectedDealLenderMessageDto;
        this.showConfirmDeleteButton = false;
        this.dataLoading = false;
      });
  }

  getSenderMessageRole() {
    if (this.isLender) {
      return MessageRoleEnum.Lender;
    } else if (this.isBroker) {
      return MessageRoleEnum.Broker;
    } else if (this.isAdmin) {
      return MessageRoleEnum.Admin;
    } else if (this.isClient) {
      return MessageRoleEnum.Client;
    }
  }

  async getCurrentUserAndRoles() {
    this.dataLoading = true;
    [this.currentUser, this.isClient, this.isAdmin, this.isBroker, this.isLender] = await Promise.all([
      getOneUsingOData(this.applicationUserCrudClient, {
        filter: { id: { eq: await this.indexService.currentUserId } },
        select: { id: true, email: true, phoneNumber: true, fullName: true, isConnectUser: true },
      }),
      this.roleService.isClientUser(),
      this.roleService.isAdminUser(),
      this.roleService.isBroker(),
      this.roleService.isLenderUser(),
    ]);

    if (!this.isLender) {
      this.toggleFeedbackSection = true;
      this.updateCaseLenderMessageReadDatetime();
    }
    this.dataLoading = false;
  }

  isCurrentUserAllowedToSendChat() {
    if (this.toggleFeedbackSection || this.showFeedbackSectionLender) {
      return true;
    }
    return false;
  }

  showActionButtons() {
    if (
      this.currentCaseLender &&
      (this.currentCaseLender.caseLenderState == CaseLenderStateEnum.Received ||
        this.currentCaseLender.caseLenderState == CaseLenderStateEnum.Rejected ||
        this.currentCaseLender.caseLenderState == CaseLenderStateEnum.Offered ||
        this.currentCaseLender.caseLenderState == CaseLenderStateEnum.Cancelled ||
        this.currentCaseLender.caseLenderState == CaseLenderStateEnum.Withdrawn)
    ) {
      return true;
    } else {
      return false;
    }
  }
}
